const services = ConstantDatas.services;

window.onload = function mapAllServices() {
  const servicesRow = document.querySelector("#services");

  servicesRow.innerHTML = services
    .map(({ id, icon, title, description, url }) => {
      return `
        <div class="col-lg-4" data-id="${id}">
          <div class="services-box">
            <div class="box-title">
              <i class="far fa-${icon}"></i>
              <span>${title}</span>
            </div>
            <div class="box-content mt-3">
              <p>${description}</p>
            </div>
            <div class="box-footer">
              <a href="${url}" class="blue-link-with-arrow">Daha ətraflı</a>
            </div>
          </div>
        </div>
        `;
    })
    .join("");
};
